/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash-compat/utility/identity.js
 ** module id = 113
 ** module chunks = 0
 **/